import axios from 'axios';

const basePath = 'https://api.scripture.api.bible/v1';

const request = (key, path) => axios
  .get(basePath + path, { headers: { 'api-key': key } })
  .then(res => res)
  .catch(err => err);

const bible = {
  // list of bibles authorized by the api key
  versions: key => request(key, '/bibles'),

  // single bible for given bible id
  version: (key, bibleId) => request(key, `/bibles/${bibleId}`),

  // array of book objects for bible id
  books: (key, bibleId) => request(key, `/bibles/${bibleId}/books`),

  // single book object for given bible id and book id
  book: (key, bibleId, bookId) => request(key, `/bibles/${bibleId}/books/${bookId}`),

  // array of chapter objects for given bible id and book id
  chapters: (key, bibleId, bookId) => request(key, `/bibles/${bibleId}/books/${bookId}/chapters`),

  // single chapter object for given bible id, book id, and chapter id
  chapter: (key, bibleId, chapterId) => request(key, `/bibles/${bibleId}/chapters/${chapterId}`),

  // array of verse objects for given bible id and chapter id
  verses: (key, bibleId, chapterId) => request(key, `/bibles/${bibleId}/chapters/${chapterId}/verses`),

  // array of verse objects for given bible id and chapter id
  verse: (key, bibleId, verseId) => request(key, `/bibles/${bibleId}/verses/${verseId}`),

  // search object including an array of verse objects for given bible id and search query
  search: (key, bibleId, search) => request(key, `/bibles/${bibleId}/search?query=${search}&limit=20`),
};

export default bible;
